import AccountBoxIcon from '@mui/icons-material/AccountBox';
import DashboardIcon from '@mui/icons-material/Dashboard';
import Logout from '@mui/icons-material/Logout';
import {
  Box,
  Divider,
  IconButton,
  Link,
  ListItemIcon,
  Menu,
  MenuItem,
} from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../../modules/users';
import CustomAvatar from '../elements/CustomAvatar';
import { NewReleases } from '@mui/icons-material';

export default function AccountMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const currentUser = JSON.parse(localStorage.getItem('user'));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();

  const logoutUser = async () => {
    await signOut();
    localStorage.setItem('isLoggedIn', false);
    localStorage.clear();
    navigate('/login', { replace: true });
  };

  const accountMenuItems = [
    {
      label: 'Profile',
      icon: <AccountBoxIcon fontSize="small" />,
      href: '/account',
    },
    {
      label: 'Dashboard',
      icon: <DashboardIcon fontSize="small" />,
      href: '/dashboard',
    },
    {
      label: 'Updates',
      icon: <NewReleases fontSize="small" />,
      href: '/updates',
    },
  ];

  const superAdminAccountMenu = [
    {
      label: 'Profile',
      icon: <AccountBoxIcon fontSize="small" />,
      href: '/account',
    },
  ];

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
        }}>
        <IconButton
          onClick={handleClick}
          size="small"
          disableRipple
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}>
          <CustomAvatar
            firstName={currentUser?.first_name}
            lastName={currentUser?.last_name}
            showTitle={false}
          />
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        {currentUser?.role === 'super-admin'
          ? superAdminAccountMenu.map((item) => (
              <Link
                key={item.href}
                underline="none"
                color="inherit"
                href={item.href}>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  {item.label}
                </MenuItem>
              </Link>
            ))
          : accountMenuItems.map((item) => (
              <Link
                key={item.href}
                underline="none"
                color="inherit"
                href={item.href}>
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  {item.label}
                </MenuItem>
              </Link>
            ))}
        <Divider />
        <MenuItem onClick={logoutUser}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
